import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  .registration-page {
    .registration-area {
      padding: 70px 0;
      .registration-box {
        max-width: 500px;
        margin: auto;
        border: 1px solid ${colors.border1};
        box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
        padding: 25px 30px;
        border-radius: 5px;
        .registration-title {
          h3 {
            color: ${colors.black2};
            text-transform: uppercase;
            font-weight: 600;
            padding-bottom: 10px;
            margin-bottom: 20px;
            position: relative;
            &:before {
              position: absolute;
              content: '';
              background: ${colors.blue2};
              width: 50px;
              height: 2px;
              bottom: 0;
              left: 50%;
              margin-left: -25px;
            }

            @media (max-width: 575px) {
              font-size: 20px;
            }
          }
        }

        .info {
          margin-bottom: 1rem;
          padding: 0.5rem;
          border-radius: 8px;
          background-color: ${colors.blue}1a;
        }

        .registration-success {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          padding: 0px 10px;
          .registration-success-message {
            padding: 10px;
            p {
              font-size: 15px;
            }
          }
          .registration-success-actions {
            width: 200px;
            button {
              display: flex;
              align-items: center;
              justify-content: center;
              text-transform: none;
              .button-icon {
                align-self: flex-start;
                margin-left: 10px;
                margin-top: 9px;
              }
            }
          }
        }

        .have_account-btn {
          p {
            font-size: 14px;
            color: ${colors.text3};
            a {
              font-size: 14px;
              color: ${colors.blue2};
              font-weight: 500;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
      .recaptcha-area {
        div {
          display: inline-block;
        }
      }
      @media (max-width: 767px) {
        padding: 30px 0;
      }
    }
  }
`;

export const StyledButton = styled.button`
  font-size: 16px;
  color: #fff;
  background: ${colors.grBg};
  width: 100%;
  height: 48px;
  font-weight: 500;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  margin-bottom: 20px;

  &:hover {
    background: ${colors.grBg2};

    i {
      color: #ffffff;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .spinner-border {
    width: 1.2em;
    height: 1.2em;
    margin-left: 10px;
    border-width: 2px;
  }

  @media (max-width: 575px) {
    font-size: 15px;
    height: 40px;
  }
`;
